import type { Writable } from "svelte/store"

const map = new Map<string, unknown>()

export const setContext = <T extends Writable<any>>(id: string, value: T) => map.set(id, value)
export const getContext = <T extends Writable<any>>(id: string) => map.get(id) as T
